module.exports = __webpack_public_path__ + "img/board.b8e610a0.png";